import React, { Component } from 'react';
import debounce from 'lodash/debounce';
import GiphyItem from 'components/GiphyUpload/GiphyItem';
import SearchBar from 'components/GiphyUpload/SearchBar';
import TextButton from 'components/TextButton';
import ModalCloseIcon from 'resources/icon-modal-close.svg';
import './GiphyUpload.css';

const trendingLimit = '25';
const trendingURL = `https://api.giphy.com/v1/gifs/trending?api_key=${process.env.REACT_APP_GIPHY_API_KEY}&limit=${trendingLimit}&rating=G`;
const defaultTerm = {
  trending: 'Trending',
  haha: 'HaHa',
  winnder: 'Winner',
  love: 'Love',
  reactions: 'Reactions'
};

class GiphyUpload extends Component {
  constructor(props) {
    super(props);

    this.state = {
      gifs: [],
      isLoaded: false,
      selected: 0,
      selectedGif: '',
      previewGif: false,
      term: 'Trending'
    };

    this.handleTermChange = this.handleTermChange.bind(this);
    this.rightClick = this.moveRight.bind(this);
    this.leftClick = this.moveLeft.bind(this);
    this.onGifSelect = this.onGifSelect.bind(this);
    this.removeGif = this.removeGif.bind(this);
    this.handleResolvedJSON = this.handleResolvedJSON.bind(this);
    this.makeRequest = this.makeRequest.bind(this);
    this.makeDebounceRequest = this.makeDebounceRequest.bind(this);
    this.generateSearchUrl = this.generateSearchUrl.bind(this);
  }

  componentDidMount() {
    try {
      fetch(trendingURL)
        .then(this.handleResponse)
        .then(this.handleResolvedJSON);
    } catch (error) {
      console.error(error);
    }
  }

  generateSearchUrl = (word, limit = 25) =>
    `https://api.giphy.com/v1/gifs/search?q=${encodeURIComponent(
      word
    )}&api_key=${
      process.env.REACT_APP_GIPHY_API_KEY
    }&limit='${limit}'&rating=G`;

  handleTermChange(term) {
    const searchURL = this.generateSearchUrl(term || defaultTerm.trending);

    if (term !== '') {
      this.setState({ term });
      this.makeDebounceRequest(searchURL);
    } else {
      this.setState({ term: defaultTerm.trending });
      this.makeDebounceRequest(searchURL);
    }
  }

  handleKeywordChange(keyword) {
    const searchURL = this.generateSearchUrl(keyword);
    this.setState({ term: keyword });
    this.makeRequest(searchURL);
  }

  makeRequest(url) {
    try {
      fetch(url).then(this.handleResponse).then(this.handleResolvedJSON);
    } catch (error) {
      console.error(error);
    }
  }

  makeDebounceRequest = debounce(url => {
    this.makeRequest(url);
  }, 500);

  handleResponse(response) {
    return response.json().then(json => {
      if (!response.ok) {
        const error = Object.assign({}, json, {
          status: response.status,
          statusText: response.statusText
        });

        return Promise.reject(error);
      }
      return json;
    });
  }

  handleResolvedJSON(json) {
    if (json.data.length > 0) {
      const sizeMB = x => {
        const gifSize = x.images.downsized || x.images.fixed_width;
        return gifSize && gifSize['size'] < 10 * 1000 * 1000;
      };
      const filteredGifs = json.data.filter(sizeMB);
      this.setState({ isLoaded: true, gifs: filteredGifs });
    } else {
      this.setState({ isLoaded: true, gifs: [] });
    }
  }

  generateGifs() {
    const { gifs } = this.state;
    return gifs.map((gif, index) => (
      <GiphyItem
        key={index}
        gif={gif}
        onGifSelect={this.onGifSelect}
        aira-posinset={index + 1}
        aria-setsize={gifs.length}
      />
    ));
  }

  onGifSelect(url) {
    const { handleGiphyUrl } = this.props;
    if (url) {
      handleGiphyUrl(url);
      this.setState({ selectedGif: url, previewGif: true });
    }
  }

  removeGif() {
    this.setState({ previewGif: false, selectedGif: '' });
    this.props.handleGiphyUrlClear();
  }

  moveRight() {
    const { gifs, selected } = this.state;
    this.setState({
      selected: (selected + 1) % gifs.length
    });
  }

  moveLeft() {
    const { gifs, selected } = this.state;
    let newSelected = selected;
    newSelected--;
    this.setState({
      selected: newSelected < 0 ? gifs.length - 1 : newSelected
    });
  }

  render() {
    let { isLoaded, selectedGif, previewGif, gifs, term } = this.state;
    const isActiveKeyWord = Object.values(defaultTerm).includes(term);

    if (!isLoaded) {
      return <div>Loading...</div>;
    } else {
      return (
        <div className="giphy-upload">
          {!previewGif && (
            <>
              <div className={`giphy-search-container${!previewGif ? '' : ''}`}>
                <SearchBar
                  term={isActiveKeyWord ? '' : term}
                  onTermChange={this.handleTermChange}
                />
              </div>
              <div className="giphy-search-buttons">
                {Object.values(defaultTerm).map(value => (
                  <button
                    className={`giphy-trending-search-button${
                      term === value ? ' active' : ''
                    }`}
                    type="button"
                    onClick={() => this.handleKeywordChange(value)}
                  >
                    {value}
                  </button>
                ))}
              </div>
            </>
          )}
          {!previewGif && !!gifs.length && (
            <div className="giphy-list-container">{this.generateGifs()}</div>
          )}
          {previewGif && (
            <React.Fragment>
              <div className="selected-giphy">
                <img
                  className={'selected-animated-gif'}
                  src={selectedGif}
                  alt={'Animated Gif Preview'}
                />
              </div>
              <TextButton
                className={'exit-preview-selected'}
                onClick={this.removeGif}
              >
                <img src={ModalCloseIcon} alt={'Exit Gif Preview View'} />
              </TextButton>
            </React.Fragment>
          )}
          {!gifs.length && !previewGif && (
            <div className={'empty-giphy-response'}>
              There are no GIFs for that search term.
            </div>
          )}
        </div>
      );
    }
  }
}

export default GiphyUpload;
